import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
import '../header-component/header-component'
import '../loader-component/loader-component'
import { escapeRegExp } from 'lodash';


/**

#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/about-component.PNG)

#### Content Type
nypwebc_ct_about

 */
@Component({
  tag: 'about-component',
  styleUrl: 'about-component.css',
  scoped: true
})

export class AboutComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
   *Optional - image location - left, right,top or bottom
   */
  @Prop() imagepos: string = "none";

  /**
   *Optional - image col span  if image pos is  left or  right. default is 3
   */
  @Prop() imagecolspan: number = 3;


  /**
   *Optional - To show/hide header - default is true
   */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
*Optional -header text color
*/
  @Prop() headertextcolor: string = "black"
  /**
*Optional -header border bottom css
*/
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
*Optional -embeded video true or false
*/
  @Prop() embededvideo: boolean = false

  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";



  @State() isLoading: boolean = true
  @State() items: []

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }


    const filter = "nypwebc_Active eq 1";

    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_Body,nypwebc_Url,nypwebc_ImageUrl&$filter=" + filter + "&$top=1", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  getContents = () => {

    const contentsArray = []
    this.items.forEach((item: any) => {
      let altImage = item.Title + " image"

      let bodystring: string = ""
      let domNode: any;
      let bodyexist: boolean = false

      if (item.nypwebc_Body != null) {
        if (this.embededvideo) {
          bodystring = item.nypwebc_Body.replaceAll('&#160;', '')
        }
        else {
          bodystring = item.nypwebc_Body
        }

        bodyexist = true;
        let parser = new DOMParser();
        domNode = parser.parseFromString(bodystring, "text/html");
        const img = domNode.querySelectorAll("img");
        const tables = domNode.querySelectorAll("table");
        const videos = domNode.querySelectorAll("video");

        for (let i = 0; i < img.length; i++) {
          img[i].classList.add("sc-about-component", "img-fluid", "rounded");
        }

        if (this.embededvideo) {
          for (let i = 0; i < videos.length; i++) {
            videos[i].setAttribute("controls", "controls")
          }
        }

        for (let i = 0; i < tables.length; i++) {
          tables[i].classList.add("sc-about-component", "table");
        }

        for (let i = 0; i < tables.length; i++) {
          let parent = tables[i].parentNode;
          let divWrapper = document.createElement("div");
          divWrapper.classList.add("sc-about-component", "table-responsive", "tableborder")
          parent.replaceChild(divWrapper, tables[i]);
          divWrapper.appendChild(tables[i]);
        }

      }

      if (item.nypwebc_ImageUrl) {

        if (this.imagepos === "top") {
          contentsArray.push(
            <div key={item.ID}>
              <div class="col-md-12"  >
                <a href={item.nypwebc_Url} target= "_blank"  data-interception="off" >
                  <img id="about-image" src={item.nypwebc_ImageUrl} class="img-fluid rounded mx-auto d-block " alt={altImage} /></a>
              </div>
              <div class="col-md-12" >
                {bodyexist ?
                  <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                  :
                  <div></div>
                }
              </div>
            </div>
          )
        }
        else if (this.imagepos === "bottom") {
          contentsArray.push(
            <div key={item.ID} >
              <div class="col-md-12">
                {bodyexist ?
                  <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                  :
                  <div></div>
                }
              </div>

              <div class="col-md-12"  >
                <a href={item.nypwebc_Url} target= "_blank"  data-interception="off"  >
                  <img id="about-image" src={item.nypwebc_ImageUrl} class="img-fluid rounded mx-auto d-block " alt={altImage} /></a>
              </div>
            </div>
          )
        }

        else if (this.imagepos === "left") {
          let imagestyle = "col-md-" + this.imagecolspan + " img-fluid rounded  mx-auto d-block  float-md-start"
          contentsArray.push(
            <div key={item.ID} >
              <a href={item.nypwebc_Url} target= "_blank"  data-interception="off"   >
                <img id="about-image" src={item.nypwebc_ImageUrl} class={imagestyle} alt={altImage} /></a>


              {bodyexist ?
                <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                :
                <div></div>
              }
            </div>
          )
        }
        else if (this.imagepos === "right") {
          let imagestyle = "col-md-" + this.imagecolspan + " img-fluid rounded  mx-auto d-block  float-md-end"
          contentsArray.push(
            <div key={item.ID} >
              <a href={item.nypwebc_Url}  target= "_blank"  data-interception="off"  >
                <img id="about-image" src={item.nypwebc_ImageUrl} class={imagestyle} alt={altImage} /></a>

              {bodyexist ?
                <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                :
                <div></div>
              }
            </div>
          )
        }
        else {
          contentsArray.push(
            <div key={item.ID} >
              <div>
                {bodyexist ?
                  <p > <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
                  :
                  <div></div>
                }
              </div>
            </div>
          )

        }
      }
      else {
        contentsArray.push(
          <div key={item.ID} >
            <div>
              <p> <div class="raw-html-style" innerHTML={domNode.body.innerHTML} /> </p>
            </div>
          </div>
        )
      }

    })
    return contentsArray
  }

  render() {
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }


    return (
      this.isLoading ?
        <loader-component /> :
        this.header && this.items.length > 0 ?
          <div >
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>

                {this.getContents()}

              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>

              {this.getContents()}

            </div>
          </div>

    )



  }

}
